
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff, Mail, User, Lock } from "lucide-react";

interface AuthFormFieldsProps {
  isLogin: boolean;
  email: string;
  setEmail: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  fullName: string;
  setFullName: (value: string) => void;
  showPassword: boolean;
  setShowPassword: (value: boolean) => void;
}

const AuthFormFields = ({
  isLogin,
  email,
  setEmail,
  password,
  setPassword,
  fullName,
  setFullName,
  showPassword,
  setShowPassword
}: AuthFormFieldsProps) => {
  return (
    <>
      {/* Full Name - only show on sign up */}
      {!isLogin && (
        <div className="space-y-2">
          <Label htmlFor="fullName">Täisnimi</Label>
          <div className="relative">
            <Input
              id="fullName"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="Jaan Tamm"
              className="pl-10"
              required
            />
            <User className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          </div>
        </div>
      )}
      
      {/* Email */}
      <div className="space-y-2">
        <Label htmlFor="email">E-post</Label>
        <div className="relative">
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="sinu.email@näide.ee"
            className="pl-10"
            required
          />
          <Mail className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        </div>
      </div>
      
      {/* Password */}
      <div className="space-y-2">
        <Label htmlFor="password">Parool</Label>
        <div className="relative">
          <Input
            id="password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            className="pl-10 pr-10"
            required
            minLength={6}
          />
          <Lock className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-3 text-muted-foreground"
            tabIndex={-1}
          >
            {showPassword ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default AuthFormFields;
